import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { NgxSpinnerModule } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { environment } from "../../../environments/environment";
import {ghabzinoPlatformName, itollPlatformName, mashalPlatformName} from "../../utils/constants";

@Component({
  selector: 'app-loading',
  standalone: true,
  imports: [NgxSpinnerModule],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent implements OnInit , OnDestroy{


  private translateSubscription: Subscription = new Subscription();
  private platform:string = environment.theme;

  textColor:string="#0049B0";
  bgColor:string="rgb(220 224 229 / 90%)";
  spinnerType:string="ball-triangle-path";
  spinnerText:string="لطفا صبر کنید";
  constructor(){}

  ngOnInit(): void {
    this.generateTheme();
  }

  private generateTheme(){
    if (this.platform==ghabzinoPlatformName){
      this.textColor="#339966";
      this.bgColor="rgba(42,83,42,0.2)";
      this.spinnerType="ball-scale-pulse";
      this.spinnerText="لطفا شکیبا باشید";
    }else if (this.platform==mashalPlatformName){
      this.textColor="#bb1e2d";
      this.bgColor="rgba(187,30,45,0.3)";
      this.spinnerType="ball-atom";
      this.spinnerText="لطفا منتظر بمانید";
    }else if (this.platform==itollPlatformName){
      this.textColor="#3058bc";
      this.bgColor="rgba(48,88,188,0.51)";
      this.spinnerType="ball-clip-rotate-pulse";
      this.spinnerText="لطفا صبر کنید";
    }
  }

  ngOnDestroy() {
    this.translateSubscription.unsubscribe();
  }


  // ball-triangle-path

  // ball-scale-ripple

  // ball-scale-pulse

  // ball-scale-multiple

  // ball-fussion

  // ball-clip-rotate-pulse

  // ball-clip-rotate-multiple

  // ball-clip-rotate

  // ball-atom

}
